/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

function AppLink({
  linkText,
  className,
  variant,
  onClick,
  href,
  isLink,
  ...props
}) {
  return isLink ? (
    <a {...props} className={`${className} app-link-${variant}`} href={href}>
      {linkText}
    </a>
  ) : (
    <a
      {...props}
      className={`${className} app-link-${variant}`}
      onClick={onClick}
    >
      {linkText}
    </a>
  );
}

AppLink.defaultProps = {
  variant: 'purple',
  className: '',
  isLink: false,
  href: '',
  onClick: () => {},
};

AppLink.propTypes = {
  className: PropTypes.string,
  isLink: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
  linkText: PropTypes.any.isRequired,
  variant: PropTypes.oneOf([
    'purple',
    'primary',
    'secondary',
    'black',
    'grey',
    'red',
    'white',
    'orange',
    'green',
    'sortopt',
  ]),
};

export default AppLink;
